const axios = require('axios');
angular
   .module('org.saga.task', [
      'org.saga.addobject',
      'org.saga.addobjectwithrole',
      'org.saga.commands',
      'org.saga.loadingOverlay',
      'org.saga.service',
      'org.saga.suspend',
      'org.saga.taskdesign',
      'org.saga.toolbar'
   ])

   .controller('TaskController', [
      '$location',
      '$log',
      '$mdSidenav',
      '$rootScope',
      '$routeParams',
      '$scope',
      '$timeout',
      'AuthSharedService',
      'Edge',
      'ErrorToast',
      'HumanTask',
      'HumanTaskChained',
      'HumanTaskOperation',
      'Instance',
      'InstanceExpression',
      'LoadingService',
      'SuspendDialog',
      'Task',
      'TaskUrl',
      'Utils',
      'Work',
      function (
         $location,
         $log,
         $mdSidenav,
         $rootScope,
         $routeParams,
         $scope,
         $timeout,
         AuthSharedService,
         Edge,
         ErrorToast,
         HumanTask,
         HumanTaskChained,
         HumanTaskOperation,
         Instance,
         InstanceExpression,
         LoadingService,
         SuspendDialog,
         Task,
         TaskUrl,
         Utils,
         Work
      ) {
         $scope.taskid = $routeParams.taskid;
         $scope.mode = $routeParams.mode;
         $scope.isClientMode = $scope.mode === 'client';
         $scope.addObjectOpen = false;

         $scope.isDesigner = function () {
            return AuthSharedService.isAuthorized('DESIGNER');
         };

         $rootScope.contextInfo = {};
         $scope.humantask = null;
         $rootScope.designModel = { designMode: $scope.isDesigner(), showDebug: false };

         $scope.evaluateExpression = InstanceExpression.get;

         let hto = new HumanTaskOperation();
         hto.id = $scope.taskid;
         hto.operation = 'START';

         $scope.toggleDesignMode = function () {
            $rootScope.designModel.designMode = !$rootScope.designModel.designMode;
            $mdSidenav('left-side-nav').toggle();
         };

         const handleCloseWindow = function (state) {
            if ($scope.mode === 'internal') {
               location.href = '/v2/tasks';
            } else {
               $location.path('/taskinfo/' + $scope.taskid + '/' + state);
            }
         };

         let originalAttributes = {};

         function startTask() {
            LoadingService.startLoading();
            hto.$update(
               function(ht) {
                  $log.info('human task ' + hto.id + ' taken');
                  $scope.ht = ht;
                  $scope.humantask = ht;
                  $scope.instanceId = ht.instance.instanceId;

                  $rootScope.contextInfo = { taskId: $scope.taskid };

                  Instance.get(
                     { instanceId: $scope.instanceId },
                     function(instance) {
                        $log.info('instance loaded ' + $scope.instanceId);
                        originalAttributes = angular.copy(instance.attributes);
                        $scope.instance = instance;

                        // NOTE: Add any data from the instance to contextInfo
                        if (
                           typeof $scope.instance.attributes.loanRequest !== 'undefined' &&
                           typeof $scope.instance.attributes.loanRequest.id !== 'undefined'
                        ) {
                           $rootScope.contextInfo = {
                              instanceId: $scope.instanceId,
                              taskId: $scope.taskid,
                              caseId: $scope.instance.attributes.loanRequest.id
                           };
                        } else {
                           $rootScope.contextInfo = {
                              instanceId: $scope.instanceId,
                              taskId: $scope.taskid
                           };
                        }

                        Task.get(
                           {
                              name: $scope.instance.name,
                              uuid: $scope.instance.uuid,
                              taskName: $scope.ht.name
                           },
                           function(task) {
                              $log.info('design task ' + $scope.ht.name + ' loaded');
                              $scope.screen = task;
                              $scope.screenLabel =
                                 $scope.screen.label + ', ' + $scope.instance.description;
                              Edge.init($scope.instance, $scope.screen, $scope.ht);
                              LoadingService.stopLoading();
                           },
                           function(taskError) {
                              LoadingService.stopLoading();
                              $scope.showError('TaskDesignError', taskError.data.value);
                           }
                        );
                     },
                     function(instanceError) {
                        LoadingService.stopLoading();
                        $scope.showError('LoadInstanceError', instanceError.data.value);
                     }
                  );
               },
               function() {
                  HumanTask.get(
                     { id: $scope.taskid },
                     function(ht) {
                        LoadingService.stopLoading();
                        if (ht.status === 'COMPLETED') {
                           handleCloseWindow('TaskCompleted');
                        } else {
                           $scope.showError('TakeClaimError');
                        }
                     },
                     function() {
                        LoadingService.stopLoading();
                        $scope.showError('TakeClaimError');
                     }
                  );
               }
            );
         }

         startTask();

         $scope.showError = function (message, error) {
            ErrorToast.show(message, error, function () {
               handleCloseWindow('TaskLoadError');
            });
         };

         $scope.isSectionVisible = (section) => Edge.isVisible(section);

         $scope.commandFunction = function (command) {
            $log.info('command = ' + command.type);
            const fn = $scope.possibleCommands[command.type];
            fn(command);
         };

         const getChangedInstanceAttrs = () =>
            Utils.getChangedAttributes($scope.instance.attributes, originalAttributes);

         $scope.save = function () {
            const instance = angular.copy($scope.instance);
            instance.attributes = getChangedInstanceAttrs();
            LoadingService.startLoading();

            Instance.update(
               { humantaskid: $scope.taskid },
               { ...instance },
               function () {
                  //on success
                  let hto = new HumanTaskOperation();
                  hto.id = $scope.taskid;
                  hto.operation = 'STOP';
                  hto.$update(
                     function () {
                        LoadingService.stopLoading();
                        $log.info('task saved');
                        handleCloseWindow('TaskSaved');
                     },
                     function (taskError) {
                        LoadingService.stopLoading();
                        $scope.showError('SaveInstanceError', taskError.data.value);
                     }
                  );
               },
               function (instanceError) {
                  LoadingService.stopLoading();
                  $scope.showError('SaveInstanceError', instanceError.data.value);
               }
            );
         };

         $scope.internalComplete = function (callback) {
            const nominalWork = Work.nominalWork($scope.instance, $scope.screen);
            $scope.instance.attributes = getChangedInstanceAttrs();
            $scope.instance.snapshots = [];
            LoadingService.startLoading();
            $scope.instance.$update(
               { humantaskid: $scope.taskid },
               (instance) => {
                  let hto = new HumanTaskOperation();
                  hto.id = $scope.taskid;
                  hto.operation = 'COMPLETE';
                  hto.nominalWork = nominalWork;
                  hto.$update(
                     function (task) {
                        HumanTaskChained.getChainedTask(
                           { id: task.id },
                           function (task) {
                              LoadingService.stopLoading();
                              $location.path(TaskUrl.get(task.id));
                           },
                           function () {
                              LoadingService.stopLoading();
                              callback(instance);
                           }
                        );
                     },
                     function (taskError) {
                        LoadingService.stopLoading();
                        $scope.showError('TaskCompleteError', taskError.data.value);
                     }
                  );
               },
               function (instanceError) {
                  LoadingService.stopLoading();
                  $scope.showError('SaveInstanceError', instanceError.data.value);
               }
            );
         };

         $scope.suspend = function (command) {
            $scope.instance.attributes = getChangedInstanceAttrs();
            LoadingService.startLoading();
            $scope.instance.$update({ humantaskid: $scope.taskid }, function () {
               let hto = new HumanTaskOperation();
               hto.id = $scope.taskid;
               hto.suspension = command.suspension;
               hto.operation = 'SUSPEND';
               hto.$update(
                  function () {
                     LoadingService.stopLoading();
                     $log.info('task suspended');
                     handleCloseWindow('TaskSaved');
                  },
                  function (taskError) {
                     LoadingService.stopLoading();
                     $scope.showError('TaskCompleteError', taskError.data.value);
                  }
               );
            });
         };

         $scope.exit = function () {
            LoadingService.startLoading();
            let hto = new HumanTaskOperation();
            hto.id = $scope.taskid;
            hto.operation = 'EXIT';
            hto.$update(
               function () {
                  LoadingService.stopLoading();
                  $log.info('task exited');
                  handleCloseWindow('TaskSaved');
               },
               function (taskError) {
                  LoadingService.stopLoading();
                  $scope.showError('TaskCompleteError', taskError.data.value);
               }
            );
         };

         $scope.complete = function () {
            $scope.internalComplete(function () {
               $log.info('task completed');
               handleCloseWindow('TaskCompleted');
            });
         };

         $scope.update = function (enableCommands) {
            const instance = angular.copy($scope.instance);
            instance.attributes = getChangedInstanceAttrs();
            LoadingService.startLoading();

            Instance.update(
               { humantaskid: $scope.taskid },
               { ...instance },
               function () {
                  LoadingService.stopLoading();
                  enableCommands = true;
                  ErrorToast.show('UpdateTask', '', function () {});
               },
               function (instanceError) {
                  LoadingService.stopLoading();
                  $scope.showError('SaveInstanceError', instanceError.data.value);
               }
            );
         }

         $scope.close = function () {
            $log.info('task closed');
            $location.path('/dashboard');
         };

         $scope.isFormInvalid = () => $scope.screenForm.$invalid;

         $scope.possibleCommands = {
            SAVE: $scope.save,
            COMPLETE: $scope.complete,
            EXIT: $scope.exit,
            RELEASE: $scope.release,
            CLOSE: $scope.close,
            SUSPEND: $scope.suspend,
            UPDATE: $scope.update,
         };
      }
   ]);
